import { Validators, ValidatorFn } from '@angular/forms';
import { dateBetween, validateBirthday } from './date.validator';
import { priceMax, priceMin } from './price.validator';

/**
 * @class CommonValidators
 * @desc Provides static getters for commonly used validators and validator combinations.
 *  Use them as a shorthand when setting up form groups with validators.
 * @deprecated please import individual validators as you need them
 */
export class CommonValidators {
    /**
     * @method phone
     * @desc returns validator functions for phone numbers. Allows country codes (p.e. +49),
     *  slashes, dashes, brackets and spaces to make numbers more readable to humans.
     * @returns {ValidatorFn[]} Array of validator functions required to validate phone numbers.
     */
    public static get phone(): ValidatorFn[] {
        return [
            Validators.pattern(
                /^\+?\d{1,4}?[\s]?[-.\s/]?[\s]?\(?\d{1,3}?\)?[\s]?[-.\s/]?[\s]?\d{1,4}[\s]?[-.\s/]?[\s]?\d{1,4}[\s]?[-.\s/]?[\s]?\d{1,9}[\s]?[-.\s/]?[\s]?\d{1,9}[\s]?[-.\s/]?[\s]?\d{1,9}$/,
            ),
        ];
    }

    /**
     * @method zip
     * @desc returns validator functions for german zip codes.
     * @returns {ValidatorFn[]} Array of validator functions required to validate german zip codes.
     */
    public static get zip(): ValidatorFn[] {
        return [Validators.pattern(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/), Validators.required];
    }

    /**
     * @method something
     * @desc returns validator functions for free form text inputs (min 3 digits, required).
     * @returns {ValidatorFn[]} Array of validator functions required to validate free form text inputs.
     */
    public static get something(): ValidatorFn[] {
        return [Validators.required, Validators.minLength(3)];
    }

    /**
     * @method shortSomething
     * @desc returns validator functions for free form text inputs (min 2 digits, required). Use
     *  this for names to avoid trouble with people with very short names.
     * @returns {ValidatorFn[]} Array of validator functions required to validate free form text inputs.
     */
    public static get shortSomething(): ValidatorFn[] {
        return [Validators.required, Validators.minLength(2)];
    }

    /**
     * @method bic
     * @desc returns validator functions necessary to validate BICs.
     * @returns {ValidatorFn[]} Array of necessary validator functions.
     */
    public static get bic(): ValidatorFn[] {
        return [Validators.required, Validators.pattern(/^([a-zA-Z]{6})([a-zA-Z0-9]{2}|[a-zA-Z0-9]{5})$/)];
    }

    /**
     * @method mail
     * @desc returns validator functions to validate mail input fields (required and mail).
     * @returns {ValidatorFn[]} Array of validator functions required to validate mail input fields.
     * @deprecated use [Validators.required, Validators.email] instead
     */
    public static get mail(): ValidatorFn[] {
        return [Validators.required, Validators.email];
    }

    public static birthday(minAge: number = -1, maxAge: number = -1, delimiter: string = '.'): ValidatorFn[] {
        return [Validators.required, validateBirthday(minAge, maxAge, delimiter)];
    }

    public static dateBetween(start: Date, end: Date): ValidatorFn[] {
        return [Validators.required, dateBetween(start, end)];
    }

    public static priceMin(min: number): ValidatorFn {
        return priceMin(min);
    }

    public static priceMax(max: number): ValidatorFn {
        return priceMax(max);
    }

    public static priceBetween(min: number, max: number): ValidatorFn[] {
        return [priceMin(min), priceMax(max)];
    }
}
